import classNames from 'classnames'
import { useState } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import { ReactComponent as Glow2 } from '../Glow2.svg'
import { ReactComponent as InstagramIcon } from './icon-instagram.svg'
import { ReactComponent as DiscordIcon } from './icon-discord.svg'
import { ReactComponent as YouTubeIcon } from './icon-youtube.svg'
import { ReactComponent as FriendIcon } from './icon-friend.svg'
import { ReactComponent as OtherIcon } from './icon-other.svg'
import { ReactComponent as BulletIcon } from '../bullet.svg'
import Input from '../Input'


export default function HowHeardStep({ onSubmit }) {

  let [data, setData] = useState({
    howHeard: '',
    howHeardOther: '',
  })

  let [option, setOption] = useState()
  let [other, setOther] = useState('')
  let options = [
    { icon: InstagramIcon, value: 'instagram', label: 'Durch Instagram' },
    { icon: DiscordIcon, value: 'discord', label: 'Durch Discord' },
    { icon: YouTubeIcon, value: 'youtube', label: 'Durch YouTube' },
    { icon: FriendIcon, value: 'friend', label: 'Durch einen Freund' },
    { icon: OtherIcon, value: 'other', label: 'Sonstige' },
  ]

  let disabled = !data.howHeard || (data.howHeard === 'other' && !data.howHeardOther)

  return (
    <div className='flex flex-col w-full h-full items-center justify-center relatve'>
      <Glow2 className='absolute top-0 left-0 w-full h-full' />
      <Card withGradient className='z-10'>
        <div className='px-24 py-12 flex text-white gap-36 items-center'>
          <div className='flex flex-col gap-4 w-72 items-start'>
            <div className='text-2xl font-bold'>
              Wie hast du von Edge erfahren?
            </div>
            <div className='text-neutral-500 text-lg'>
              Erzähl uns wie du über Edge erfahren hast. Ob durch einen Freund, Social Media oder Google. Let us know!
            </div>
            <Button
              variant='secondary'
              className='text-primary'
              disabled={disabled}
              onClick={() => !disabled && onSubmit(data)}
            >
              <strong className={classNames('px-12 font-bold', !disabled && 'text-primary')}>Weiter</strong>
            </Button>
          </div>

          <div className='flex flex-col gap-4'>
            {options.map((opt) => (
              <div
                key={opt.value}
                className={classNames(
                  'cursor-pointer p-3 rounded-2xl flex gap-2 items-center border-2 w-72',
                  data.howHeard === opt.value ? 'border-primary text-primary bg-secondary' : ' border-neutral-800 text-neutral-300'
                )}
                onClick={() => setData({ ...data, howHeard: opt.value })}
              >
                <opt.icon style={{ width: '28px', height: '28px' }} className={classNames(option !== opt.value && 'text-neutral-600')} />
                <span className='flex-1'>{opt.label}</span>
                <BulletIcon
                  className={classNames('ml-8 mr-2', option === opt.value ? 'text-primary' : 'text-neutral-800')}
                />
              </div>
            ))}
            {data.howHeard === 'other' && (
              <Input
                title='Bitte angeben'
                value={data.howHeardOther}
                onChange={(e) => setData({ ...data, howHeardOther: e.target.value })}
              />
            )}
          </div>
        </div>
      </Card>
    </div>
  )
}
